/**************************************************
 * Nombre:       Tarjeta_Preguntas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, IconButton, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {Add, Remove} from '@mui/icons-material'
import {useState} from "react";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Preguntas = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const [open, setOpen] = useState(false);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderTop: 1,
                borderColor: '#fff',
                color: '#fff',
                px: 1,
                py: 2
            }}

        >

            <Grid container size={{xs: 11, sm: 11, md: 11}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: !masSM ? 16 : 18, fontFamily: NEGRITA}}>{item.pregunta}</Typography>
            </Grid>

            <Grid container size={{xs: 1, sm: 1, md: 1}} sx={{justifyContent: 'flex-end'}}>
                <IconButton
                    onClick={() => setOpen(!open)}
                >
                    {open ?

                        <Remove sx={{fill: '#fff'}}/>

                        :

                        <Add sx={{fill: '#fff'}}/>
                    }

                </IconButton>
            </Grid>

            <Collapse in={open} sx={{width: '100%'}}>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Typography>{item.respuesta}</Typography>
                </Grid>
            </Collapse>

        </Grid>
    )

}
export default Tarjeta_Preguntas